import React, { Component } from 'react';
import MarkDown from './MarkDown'
import CodeHighlight from './CodeHighlight'
import MarkdownEditor from '@uiw/react-markdown-editor';
import {
  Row,
  Col,
  DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown
} from "reactstrap";
import { uuidv4, removeCell, moveupCell, movedownCell, addNewCodeAfter, addNewMarkDownAfter, clearCellOutputByIndex } from './operations/notebook';
import { saveFile } from 'components/Notebook/operations/file_handler';
import { executeCode, parseWebsocketReply } from './operations/execution_handler'
import {getonCellRenderFocus} from "../../settings/shared/commonMethod"
// import { toast } from 'settings/shared/constants';
import { toast } from 'react-toastify';


class SplitCells extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      isHovering: false,
      cell_id: '',
      mousehovercell_id: "",
      markValue: '',
      tool: [],
      toolMode: [""],
      codeFlag: false,
      markdownFlag: false,
      splitValues: [],
      lang: "python",
      latestSourceMark: "",
      latestIndexMark: 0,
      latestData: {},
      isCellBusy: false,
      cellFocusInsert : "false",
      updateStopFlag:false
    }
  }

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  SelectParticularIdMarkdown = (value, id, index, flag) => {
    this.setState({
      latestSourceMark: "",
      cellId: id,
      markValue: value,
      markdownFlag: false,
      codeFlag: false
    },()=>{
      if(flag === false){ // autofocus for top panel markdown cell creation
          var target = document.getElementById(id);
          target.parentNode.scrollTop = target.offsetTop - 10;    
      }
    })
    this.props._getSelectedIndex(index)
  }

  SelectParticularId = (value, id, index) => {
    var changeValueToString = typeof value == "string" ? value : value.join('');
    this.setState({
      cellId: id,
      // borderFocus: "markdownOutline_focus",
      markValue: changeValueToString,
      markdownFlag: true,
      codeFlag: false,
      mousehovercell_id: id
    })
    this.props._getSelectedIndex(index)
  }

  SelectParticularIdCode = (value, id, index,flag) => {
    this.setState({
      cellId: id,
      // borderFocus: "markdownOutline_focus",
      codeFlag: true,
      markdownFlag: false,
      mousehovercell_id: id,
    },()=>{
      if(flag === false){ // autofocus for top panel code cell creation
          // document.getElementById(id).scrollIntoView(scrollIntoViewOptions);
          var target = document.getElementById(id);
          target.parentNode.scrollTop = target.offsetTop -10;   
      }
    })
    // console.log(this.props.cellsData[index])
    if(!this.props.cellsData[index].metadata.hasOwnProperty("state")){
      this.props.cellsData[index].metadata.state = "idle"      
    }
    this.props._getSelectedIndex(index)
  }

  _getNewCode = (code, index,changeFlag) => {
    this.props.cellsData[index].source = code;
    // this.setState({
    //   latestData:data
    // })
    this.props._getCodeChangeIndex(changeFlag);
  }

  addCodeNumber = (cells) =>{
    if(cells.length !== 0) {
      let count = 1;
      for(var i = 0; i < cells.length; i++){
      if(cells[i].cell_type === "code"){ 
        cells[i].metadata.codeindex = count++;
        }
    }
  }
  }
  /**
   * Add new cell after current index
   * @param {Array} notebook cells array
   */
  addNewCellafterIndex = (cells, index) => {
    addNewCodeAfter(cells, index);
    this.setState({
      cellsData: cells
    })
    this.SelectParticularIdCode(cells[index+1].source,cells[index+1].metadata.decisionforce_cell_id,index+1,true)
    this.addCodeNumber(cells)

  }

  /**
   * Add new cell after current index
   * @param {Array} notebook cells array
   * @param {selected index} index 
   */
  addNewMarkdownafterIndex = (cells, index) => {
    addNewMarkDownAfter(cells, index);
    this.setState({
      cellsData: cells
    })
    this.SelectParticularIdMarkdown(cells[index+1].source,cells[index+1].metadata.decisionforce_cell_id,index+1,true)
    this.addCodeNumber(cells)
  }

  /**
   * 
   * @param {Array of cells} cells 
   * @param {selected index} index 
   */

  removeCellData = (cells, index) => {
    removeCell(cells, index);
    this.setState({
      cellsData: cells
    });
    this.addCodeNumber(cells)
  }

  /**
   * Clear output
   * @param {Array of cells} cells 
   * @param {select index} index 
   */
  clearCellOutput = (cells, index) => {
    let fileProperty = this.props.fileProperty[this.props.cellIndex];
    let updatedCells = clearCellOutputByIndex(cells, fileProperty, index);
    if (updatedCells !== undefined) {
      this.setState({
        cellsData: updatedCells
      });
    }

  }

  /**
   * move the cell to top
   * @param {Number} current index
   * @param {Number} cell target index decrement 1 with current index
   */
  moveUpcellData = (cells, index) => {
    let secondIndex = index - 1;
    if (Math.sign(secondIndex) !== -1) {
      var cellModified = moveupCell(cells, index, secondIndex);
      this.setState({
        cellsData: cellModified,
      })
    }
    this.addCodeNumber(cells)
  }

  /**
   * @param {*} user {currnetIndex, isSinglecell, cellFocusInsert}
   */
  _codeCellRender = (index, flag, msg) =>{
    this.setState({
      cellFocusInsert : msg
    },()=>{
      this.onCellRender_Code(undefined, index, flag);
    })
  }

  _saveCellRender = (index) => {
    this.savecell(index);
    this.props._stateValuesUpdate();
  }
  
 /**
 * Save cell after current index
 * @param {Array} notebook cells array
 * TODO: Enable versioning feature for notebook
 */
     savecell = (index) => {
      let currentStorageName;
      let currentrootFolder;
      if(index !== undefined){
        let data = this.props.fileProperty[index];
        currentStorageName = this.props.storageName;
        currentrootFolder = this.props.rootFolder
        if (data !== undefined) {
          let filePath = data.path;
          let fileType = data.type;
          let content = data.content;
          let metadata = data.metadata;
          let notebookContent;
          notebookContent = {
            cells: content,
            metadata: metadata,
            "nbformat": 4,
            "nbformat_minor": 0
          }
          saveFile(filePath, fileType, notebookContent, currentStorageName, currentrootFolder)
        }
      }
    }

  /**
   * move the cell to down
   * @param {Number} current index
   * @param {Number} cell target index increment 1 with current index
   */
  moveDowncellData = (cells, index) => {
    let secondIndex = index + 1;
    var cellModified = movedownCell(cells, index, secondIndex);
    this.setState({
      cellsData: cellModified,
    })
    this.addCodeNumber(cells)
  }


  saveFilebasedOnStorage = (filePath, fileType, notebookContent) =>{
    if(this.props.storageName !== undefined && this.props.rootFolder !== undefined){
      let currentStorageName = this.props.storageName
      let currentrootFolder = this.props.rootFolder
      saveFile(filePath, fileType, notebookContent, currentStorageName, currentrootFolder)
    }
  }

  stopCell = (index) => {
    let fileProperty = this.props.fileProperty[this.props.cellIndex];
    if (fileProperty !== undefined) {
      try {
        let notebookContent = fileProperty.content;
       // let notebook_metadata = fileProperty.metadata;
        let connectionId = fileProperty.wsConnectionId;
        let contentType = fileProperty.type;
        let notebook_metadata = fileProperty.metadata;
        let filePath = fileProperty.path;
        let websocket = this.props.socketConnection;
        let userId = localStorage.getItem("Uid")
        fileProperty.InterruptFlag = true;
        if(websocket !== undefined) {
          if(index === undefined) {
            for (var i = 0 ; i < notebookContent.length; i++){
              if(notebookContent[i].cell_type === 'code') {
                  notebookContent[i].metadata.state = "idle";
                  let interrupt_json = {'connectionId':connectionId, 'userId':userId, 'action':'INTERRUPT','filePath':filePath}
                  websocket.send(JSON.stringify(interrupt_json))
                  this.setState({
                    updateStopFlag:true
                  })
              }
          }
        } else {
          fileProperty.runAllFlag = true;

          if(notebookContent[index].cell_type === 'code') {
            notebookContent[index].metadata.state = "idle";
            let interrupt_json = {'connectionId':connectionId, 'userId':userId, 'action':'INTERRUPT','filePath':filePath}
            websocket.send(JSON.stringify(interrupt_json))
            this.setState({
              updateStopFlag:true
            })
        }
        }
        }else{
          fileProperty.runAllFlag = true;
          notebookContent[index].metadata.state = "idle";
          let notebookFile = {
            cells: notebookContent,
            metadata: notebook_metadata
          }
          // saveFile(filePath, contentType, notebookFile);
          this.saveFilebasedOnStorage(filePath, contentType, notebookFile);
          this.setState({
            updateStopFlag:true
          })
        }
      }catch(err) {
          if (fileProperty !== undefined) {
          fileProperty.runAllFlag = true;
          let notebookContent = fileProperty.content;
          let contentType = fileProperty.type;
          let notebook_metadata = fileProperty.metadata;
          let filePath = fileProperty.path;
          // console.log('Error in stopping ws')
          notebookContent[index].metadata.state = "idle";
            let notebookFile = {
              cells: notebookContent,
              metadata: notebook_metadata
            }
            // saveFile(filePath, contentType, notebookFile);
            this.saveFilebasedOnStorage(filePath, contentType, notebookFile);
            this.setState({
              updateStopFlag:true
            })
        }
      }
    }
  }
  /**
   * Run all cell by using recursive code
   * @param {*} ws 
   * @param {*} fileProperty 
   * @param {*} index 
   */
  onCellRender_RunAll = (ws, fileProperty, index) => {
    var _this = this;
    let notebookContent = fileProperty.content;
    let notebook_metadata = fileProperty.metadata;
    let contentType = fileProperty.type;
    let filePath = fileProperty.path;
    let interruptFlag = fileProperty.InterruptFlag; // if it is true break the run all execution
    if (interruptFlag) {
      return
    }
    if (ws !== undefined) {
      // _this.stopCell(); //Interrupt Kernel
      if (fileProperty !== undefined) {
        let notebookContent = fileProperty.content;
        if(notebookContent !== undefined && notebookContent.length > 0) {
          if(index !== undefined) {
            if(index < notebookContent.length) {
           
              if(notebookContent[index].cell_type === 'code') {
                if(notebookContent[index].source.length > 0){
                  this.process_cell_by_index(ws, fileProperty, index, false);
                }else{
                  index = index + 1;
                  _this.onCellRender_RunAll(ws, fileProperty, index);
                }
                //     , function(result, currentIndex){
                //     _this = result;
                //     index = currentIndex + 1;
                //   _this.onCellRender_RunAll(ws, fileProperty, index);  
                // });
              } else {
                index = index + 1;
                _this.onCellRender_RunAll(ws, fileProperty, index);
              }
            } else {
              let notebook_metadata = fileProperty.metadata;
              let filePath = fileProperty.path;
              let contentType = fileProperty.type;
              let notebookFile = {
                cells: notebookContent,
                metadata: notebook_metadata
              }
              // console.log(fileProperty)
              fileProperty.runAllFlag = true;
              this.setState({
                updateStopFlag:true
              })
              // console.log(fileProperty)
              // saveFile(filePath, contentType, notebookFile);
              this.saveFilebasedOnStorage(filePath, contentType, notebookFile);
              return true;
            }       
          }
        }
      }    
    }else{
      // console.log("ws undefined")
      fileProperty.runAllFlag = true;
      notebookContent[index].metadata.state = "idle";
      let notebookFile = {
        cells: notebookContent,
        metadata: notebook_metadata
      }
      // saveFile(filePath, contentType, notebookFile);
      this.saveFilebasedOnStorage(filePath, contentType, notebookFile);
      this.setState({
        updateStopFlag:true
      })
    }
  }

  getNotebookIndexByCellId = (notebook_content, df_cell_id) => {
    if(notebook_content !== undefined) {
      for(var index = 0; index < notebook_content.length; index++) {
        if(notebook_content[index].metadata.decisionforce_cell_id === df_cell_id) {
          return index;
        }
      }
    }
}

  /**
   * Execute cell by index
   * @param {*} ws 
   * @param {*} fileProperty 
   * @param {current cell index} currentIndex 
   * @param {*} isSingleCell 
   * @param {*} callback 
   */
  process_cell_by_index = (ws, fileProperty, currentIndex, isSingleCell) => {
   // var _this = this;
    if (ws !== undefined && fileProperty !== undefined && currentIndex !== undefined) {
        let notebookContent = fileProperty.content;
        let metadata = fileProperty.metadata;
        if (metadata !== undefined) {
          metadata.cellIndex = currentIndex;
          metadata.isSingleCell = isSingleCell;
        } else {
          metadata = {
            cellIndex: currentIndex,
            isSingleCell: isSingleCell
          }
        }
    //    let fileName = fileProperty.name;
        let connectionId = fileProperty.wsConnectionId;
        let filePath = fileProperty.path;
        let contentType = fileProperty.type;
        let codeCell = notebookContent[currentIndex];
        notebookContent[currentIndex].outputs = []; // Reset outputs array before render
        executeCode(ws, codeCell, metadata, connectionId, currentIndex, filePath, contentType, isSingleCell);
      }
  }
  
  /**
   * 
   * @param {websocket event data} data  
   */
  handleOutputData = (data) =>{
    // console.log(data)
      try{
        let connectionId = data.parent_header.connectionId;
        let metaData = data.parent_header.notebook_metadata
        if(connectionId !== undefined && metaData !== undefined){
          let currentIndex = metaData.cellIndex;
          let fileProperty = this.props.fileProperty;
          let wsIndex = fileProperty.findIndex(item => item.wsConnectionId === connectionId);
          let notebookContent = fileProperty[wsIndex].content;
          // console.log(notebookContent)
          // notebookContent[currentIndex].outputs = [];
          let outputResult = parseWebsocketReply(JSON.stringify(data), notebookContent[currentIndex], wsIndex)
          if (outputResult !== undefined) {
            let outputs = outputResult.outputs;
            let notebook_metadata = outputResult.notebook_metadata;
            let df_cell_id = outputResult.decisionforce_cell_id;
          //  let execution_count = outputResult.execution_count;
            let file_path = outputResult.file_path;
            let file_type = outputResult.file_type;
            let execution_state = outputResult.state;
            let current_cell_index = outputResult.current_cell_index;
            let msg_type = outputResult.output_type;
           // let is_single_cell = outputResult.is_single_cell;
            let working_cell_index = this.getNotebookIndexByCellId(notebookContent, df_cell_id);
            // console.log(working_cell_index)
            if (( outputs !== undefined) && (outputs.length > 0)) {
              if ((notebookContent !== undefined)) {
                let cell_id = notebookContent[current_cell_index].metadata.decisionforce_cell_id;
                if (cell_id === df_cell_id) {
                  notebookContent[working_cell_index].outputs = outputs;
                }
              }
            }
            try {
            this.setState({ file_path : notebookContent });
            if (execution_state !== undefined) {
              let cell_index = this.getNotebookIndexByCellId(notebookContent, df_cell_id);
              notebookContent[cell_index].metadata.state = execution_state;
              
              // set selected cellId
              this.setState({
                cellId:notebookContent[cell_index].metadata.decisionforce_cell_id,
                codeFlag:true
              })
              
              // focus busy cell by cell
              if(notebook_metadata.isSingleCell === false || notebook_metadata.isSingleCell !== undefined) {  // if single cell is false execute cell by cell focus
                  if(this._isMounted) {
                    // let cell_index = this.getNotebookIndexByCellId(notebookContent, df_cell_id);
                    // document.getElementById(notebookContent[cell_index].metadata.decisionforce_cell_id).scrollIntoView(scrollIntoViewOptions);
                    var target = document.getElementById(notebookContent[cell_index].metadata.decisionforce_cell_id);
                    target.parentNode.scrollTop = target.offsetTop - 10;   
                  }
              }
              if ((msg_type === 'execute_reply')) {
                if ((file_path !== undefined) && (notebook_metadata !== undefined)) {
                  // notebook_metadata.runAllBtn = true;
                  let notebookFile = {
                      cells: notebookContent,
                      metadata: notebook_metadata
                    }
                    if(notebook_metadata.isSingleCell === false){
                      this.onCellRender_RunAll(fileProperty[wsIndex].wsState, fileProperty[wsIndex], current_cell_index+1);  
                    }else{
                      this.saveFilebasedOnStorage(file_path, file_type, notebookFile);
                      if (this.state.cellFocusInsert === "focus") {
                        this.SelectParticularIdCode(notebookContent[current_cell_index + 1].source,
                          notebookContent[current_cell_index + 1].metadata.decisionforce_cell_id,
                          current_cell_index + 1,
                          true)
                      }                                       
                      if (this.state.cellFocusInsert === "insert") {
                        this.addNewCellafterIndex(this.props.cellsData, current_cell_index)
                      }
                      return true;
                    }
                }
              }
            }
            }catch(err) {
              // console.log("Output result =>"+err)
            }
          }

        }else{
          // console.log("connection Id undefined");
        }
      }catch(err){
        console.log("");
      }
  }

  /**
   * 
   * @param {Array} code_cell 
   * @param {Array Index} index 
   * @param {Boolean} isSingleCell //If it's false then it will iterate and execute all cells in a notebook
   */
  onCellRender_Code = (code_cell, index, isSingleCell) => {
    let indexCell = this.props.cellIndex;
    // this.setState({
    //   stopFlag:true
    // })
    if (this.props.socketStatus === "Connected") {
     // const { cellsData } = this.props;
    //  var _this = this;
      // console.log("Props Data ", this.props);
      let fileProperty = this.props.fileProperty;

      // let file_path = '';
      // let file_type = '';
      // let metadata = '';
      let interruptFlag = fileProperty.InterruptFlag; // if it is true break the run all execution
      if (interruptFlag) {
        return
      }

      if ((fileProperty !== undefined) && (Array.isArray(fileProperty))) {
        // console.log('File Properties ', fileProperty)
        // file_path = fileProperty[indexCell].path;
        // file_type = fileProperty[indexCell].type;
        // metadata = fileProperty[indexCell].metadata
      }
      this.props.cellsData[index].outputs = [] // Reset outputs array before render
      let websocket = this.props.socketConnection;
      if (websocket !== undefined) {
        this.process_cell_by_index(websocket, fileProperty[indexCell], index, isSingleCell);
      }
    }
    else if (this.props.socketStatus === "Closed") {
      // toast.warning("Please Connect Environment")
    }
    else if (this.props.socketStatus === "Connecting") {
      // toast.warning("Environment Connecting Please wait")
    }
    else if (this.props.socketStatus === undefined) {
      toast.info("Runtime Environment Not Connected");
    }
  }

  onCellRender_Mark = () => {
    if (this.state.latestSourceMark !== "") {
      this.props.cellsData[this.state.latestIndexMark].source = this.state.latestSourceMark;
      this.setState({
        markdownFlag: false
      })
    } else {
      console.log("")
    }
  }


  handleChangeMarkDown = (text, index) => {
    // this.props.cellsData[index].source=text;
    this.setState({
      latestIndexMark: index,
      latestSourceMark: text
    })

  };

  render() {
    // console.log(this.state.cellsData)
    return (this.props.cellsData !== "" ? this.props.cellsData.map((item, index) => (<div key={index} id={item.metadata.decisionforce_cell_id} style={{ marginTop: 20 }} >
        {!this.state.markdownFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) && item.cell_type === "markdown" && <Row><Col xs="10"><span className="hoverMark"><i className="fa fa-info-circle" style={{ marginRight: 3 }} aria-hidden="true"></i>
     double-click on this cell to edit it</span></Col></Row>}
        {/* if cell type is mark down */}
        {item.cell_type === "markdown" &&
          <div>
            <div className={!this.state.markdownFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) ? "markdownOutlineSelect" : ""}>
              <div
                className={this.state.markdownFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) ? "markdownOutline" : ""}
                onDoubleClick={e => this.SelectParticularId(item.source, item.metadata.decisionforce_cell_id, index)}>
                {this.state.markdownFlag && item.metadata.decisionforce_cell_id === this.state.cellId &&
                  <Row>
                    {/* <Col xs="1" style={{zIndex: 3,textAlign: "center"}}>
                   <i className="fas fa-play-circle"  onClick={e=>this.onCellRender_Mark()} style={{fontSize:25,cursor:"pointer",color:"#403633"}} id={'play'+this.props.id}></i>
                  </Col> */}
                    <Col xs="12">
                      {this.state.markdownFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) && <Row style={{ float: "right" }}><Col style={{ display: "flex" }}>
                        <span title="Run" className="notepopMenu" onClick={e => this.onCellRender_Mark()}><i className="fas fa-play"></i></span>&nbsp;&nbsp;
                  <UncontrolledDropdown>
                          <DropdownToggle tag="span"
                            onClick={e => e.preventDefault()}
                            style={{ cursor: 'pointer' }}>
                            <i className="fas fa-chevron-down" style={{ fontSize: '12px' }} />
                          </DropdownToggle>
                          <DropdownMenu style={{ border: "1px solid #9c9696", borderRadius: "5px" }} persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                            flip: {
                              behavior: "flip",
                              enabled: true
                            }, preventOverflow: { boundariesElement: 'window' }
                          }}>
                            <DropdownItem href="" disabled style={{ cursor: "pointer" }} onClick={e => this.savecell(index)} className="storagedropdown_note">
                              <span>   <i className="fas fa-save" />Save Cell</span>
                            </DropdownItem>
                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.addNewCellafterIndex(this.props.cellsData, index)} className="storagedropdown_note">
                              <span><i className="fas fa-code" />Code Cell</span>
                            </DropdownItem>

                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.addNewMarkdownafterIndex(this.props.cellsData, index)} className="storagedropdown_note">
                              <span><i className="fas fa-plus" /> Markdown Cell</span>
                            </DropdownItem>

                            <DropdownItem divider />
                            <DropdownItem disabled href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                              <span>    <i className="fas fa-copy" />Copy Cell</span>
                            </DropdownItem>
                            <DropdownItem disabled href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                              <span>    <i className="fas fa-paste" />Paste Cell</span>
                            </DropdownItem>
                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.removeCellData(this.props.cellsData, index)} className="storagedropdown_note">
                              <span>    <i className="fas fa-trash" />Delete Cell</span>
                            </DropdownItem>
                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.clearCellOutput(this.props.cellsData, index)} className="storagedropdown_note">
                              <span>    <i className="fas fa-eraser" />Clear Output</span>
                            </DropdownItem>

                            <DropdownItem divider />
                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.moveUpcellData(this.props.cellsData, index)} className="storagedropdown_note">
                              <span>    <i className="fas fa-arrow-up" />Move Up</span>
                            </DropdownItem>
                            <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.moveDowncellData(this.props.cellsData, index)} className="storagedropdown_note">
                              <span>    <i className="fas fa-arrow-down" />Move Down</span>
                            </DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                              <span>    <i className="icon-comment" />Add Comment</span>
                            </DropdownItem>

                    </DropdownMenu>
                  </UncontrolledDropdown>&nbsp;&nbsp;
                  {/* <span title="Close" className="notepopMenu"><i className="fas fa-times"></i></span> */}

                      </Col>
                      </Row>}
                      <div className="markEdit">
                        <MarkdownEditor
                          value={this.state.markValue}
                          className="editorPadding"
                          autoFocus={true}
                          onChange={(editor, data, value) => this.handleChangeMarkDown(value, index)}
                          toolbars={this.state.tool}
                          toolbarsMode={this.state.toolMode}
                          visible={false}
                        />
                      </div></Col>
                  </Row>}
                <div className="displaytxt" onClick={e => this.SelectParticularIdMarkdown(item.source, item.metadata.decisionforce_cell_id, index,true)}>
                  <MarkDown markdownValue={item.source} id={item.metadata.decisionforce_cell_id}></MarkDown>
                </div>
              </div>
            </div>
          </div>
        }
        {/* if cell type is code */}
        {item.cell_type === "code" &&
          //   <div>
          //   <Row style={{float:"left"}}>
          //   <span>{item.execution_count!=null?"[  "+item.execution_count+" ]":"[ ]"}</span>
          // </Row>
          <div className={this.state.codeFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) ? getonCellRenderFocus(item.metadata.state) : ""}>

            <Row
              className={this.state.codeFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) ? "removeBorder" : ""}
              style={{ border: "1px solid #d3d3d3", marginRight: 1, marginLeft: 1 }}>
              {/* <Col xs="1" style={{background:"#fffff"}}>
              <div style={{paddingTop:5,textAlign: "center"}}>
              {this.state.codeFlag && (item.metadata.decisionforce_cell_id == this.state.cellId) ?<i className="fas fa-play-circle"  onClick={e=>this.onCellRender_Code(item)} style={{fontSize:25,cursor:"pointer",color:"#403633"}} id={'play'+this.props.id}></i>:item.execution_count!=null?"[   "+item.execution_count+"  ]":"[   ]"}
           </div>
            </Col> */}
               {/* <Col xs="1" >
               <span className="hoverMark">
                       <button class="btn-icon btn-round btn btn-linkedin">{item.metadata.codeindex}</button>  
</span>
                 </Col>     */}
      
            <Col xs="12" style={{paddingTop:3}}>
            <span className="codecount" >
                       <button className="btn-icon btn-round btn btn-linkedin" style={{cursor:'default'}}>{item.metadata.codeindex}</button>  
          </span>
            {this.state.codeFlag && (item.metadata.decisionforce_cell_id === this.state.cellId) &&<Row style={{float:"right"}}><Col style={{display:"flex"}}>
                  {/* style={localStorage.getItem("runStatus") === "busy" ? {pointerEvents: "none", opacity: "0.4"} : {}} */}
                  {(item.metadata.state === "idle" || item.metadata.state === "error" || item.metadata.state === undefined || item.metadata.state === "ok") && <span title="Run" className="notepopMenu" onClick={e => this.onCellRender_Code(item, index, true)}><i className="fas fa-play"></i></span>}&nbsp;&nbsp;
                  {item.metadata.state === "busy" && <span className="fa-stack fa-2x" style={{ fontSize: 13, color: "#53607e" }}>
                    <i className="fas fa-spinner fa-stack-2x fa-spin"></i>
                    <i style={{ fontSize: 13, color: "#53607e", marginLeft: 2 }} className="fas fa-play fa-stack-1x fa-inverse"></i>
                  </span>}&nbsp;&nbsp;

                  <UncontrolledDropdown>
                    <DropdownToggle tag="span"
                      onClick={e => e.preventDefault()}
                      style={{ cursor: 'pointer' }}>
                      <i className="fas fa-chevron-down" style={{ fontSize: '12px' }} />
                    </DropdownToggle>
                    <DropdownMenu style={{ border: "1px solid #9c9696", borderRadius: "5px" }} persist right className="dropdown-menu-arrow" flip={false} modifiers={{
                      flip: {
                        behavior: "flip",
                        enabled: true
                      }, preventOverflow: { boundariesElement: 'window' }
                    }}>
                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.savecell(index)} className="storagedropdown_note">
                        <span>   <i className="fas fa-save" />Save Cell</span>
                      </DropdownItem>

                      <DropdownItem disabled={item.metadata.state === "busy"?false:true}href="" style={{ cursor: "pointer" }} onClick={e => this.stopCell(index)} className="storagedropdown_note">
                        <span><i className="fas fa-stop" />Stop Cell</span>
                      </DropdownItem>

                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.addNewCellafterIndex(this.props.cellsData, index)}className="storagedropdown_note">
                        <span><i className="fas fa-code" />Code Cell</span>
                      </DropdownItem>

                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.addNewMarkdownafterIndex(this.props.cellsData, index)} className="storagedropdown_note">
                        <span><i className="fas fa-plus" /> Markdown Cell</span>
                      </DropdownItem>

                      <DropdownItem divider />
                      <DropdownItem disabled href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                        <span>    <i className="fas fa-copy" />Copy Cell</span>
                      </DropdownItem>
                      <DropdownItem disabled href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                        <span>    <i className="fas fa-paste" />Paste Cell</span>
                      </DropdownItem>
                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.removeCellData(this.props.cellsData, index)} className="storagedropdown_note">
                        <span>    <i className="fas fa-trash" />Delete Cell</span>
                      </DropdownItem>
                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.clearCellOutput(this.props.cellsData, index)} className="storagedropdown_note">
                        <span>    <i className="fas fa-eraser" />Clear Output</span>
                      </DropdownItem>

                      <DropdownItem divider />
                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.moveUpcellData(this.props.cellsData, index)} className="storagedropdown_note">
                        <span>    <i className="fas fa-arrow-up" />Move Up</span>
                      </DropdownItem>
                      <DropdownItem href="" style={{ cursor: "pointer" }} onClick={e => this.moveDowncellData(this.props.cellsData, index)} className="storagedropdown_note">
                        <span>    <i className="fas fa-arrow-down" />Move Down</span>
                      </DropdownItem>
                      <DropdownItem divider />
                      <DropdownItem disabled href="" style={{ cursor: "pointer" }} className="storagedropdown_note">
                        <span>    <i className="fas fa-comment" />Add Comment</span>
                      </DropdownItem>

                    </DropdownMenu>
                  </UncontrolledDropdown>&nbsp;&nbsp;
                  {/* <span title="Close" className="notepopMenu"><i className="fas fa-times"></i></span> */}

                </Col>
                </Row>}
                <div
                  onClick={e => this.SelectParticularIdCode(item.source, item.metadata.decisionforce_cell_id, index,true)}>
                  <CodeHighlight
                    codeValue={item.source}
                    data={item}
                    output={item.outputs}
                    language={this.state.lang}
                    flagId={this.state.codeFlag}
                    tabIndex = {this.props.cellIndex}
                    index={index}
                    _getNewCode={this._getNewCode}
                    _codeCellRender ={this._codeCellRender}
                    _saveCellRender = {this._saveCellRender} />
                </div>
             
              </Col>
            </Row>
          </div>
    
          // </div>
        }
      </div>)) : <div key={uuidv4()}></div>
    );
  }
}

export default SplitCells;
